import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: "web-tab-group",
    templateUrl: "./tab-group.component.html",
    styleUrls: ["./tab-group.component.scss"],
})
export class TabGroupComponent {
    @Input() tabs: any[] = [];
    @Input() selectedValue: any;

    @Output() tabChange = new EventEmitter<any>();

    selectTab(value: any): void {
        this.tabChange.emit(value);
    }
}
